/** @jsxImportSource theme-ui */

import { CheckboxGroupProps as AriaCheckboxGroupProps } from '@react-types/checkbox';
import React from 'react';
import { CheckboxGroupState, useCheckboxGroupState } from '@react-stately/checkbox';
import { useCheckboxGroup as useReactAriaCheckboxGroup } from '@react-aria/checkbox';
import { StyleOverrideProps } from '../../utils/types';
import Stack from '../../Stack';

export interface CheckboxGroupProps extends AriaCheckboxGroupProps, StyleOverrideProps {
    children?: React.ReactNode | React.ReactNodeArray;
    name: string;
}

export interface CheckboxGroupContextState extends CheckboxGroupState {
    name: string;
}

const CheckboxGroupContext = React.createContext<CheckboxGroupContextState>({} as CheckboxGroupContextState);

export const useCheckboxGroup = (): CheckboxGroupContextState => React.useContext(CheckboxGroupContext);

export function CheckboxGroup(props: CheckboxGroupProps): JSX.Element {
    const { children, label, name, sx } = props;
    const state = useCheckboxGroupState(props);
    const { groupProps, labelProps } = useReactAriaCheckboxGroup(props, state);
    return (
        <div {...groupProps}>
            <Stack spacing={'tiny'}>
                {label && (
                    <div {...labelProps} sx={{ ...sx }}>
                        {label}
                    </div>
                )}
                <CheckboxGroupContext.Provider value={{ ...state, name }}>{children}</CheckboxGroupContext.Provider>
            </Stack>
        </div>
    );
}

export interface CheckboxGroupSetValueProps extends StyleOverrideProps {
    values: string[];
    children?: React.ReactNode;
}
